import { createAction } from '@reduxjs/toolkit';
import { featuresSlice } from './reducer';

export const setupStoreFeatures = createAction('features/setupStoreFeatures');
export const fetchFeatures = createAction('features/fetchFeatures');

export const { setFeatures } = featuresSlice.actions;
